export default "__VITE_ASSET__cbKUq4h2__"